import { memo } from "react";
import { LuChevronDown } from "react-icons/lu";

/** Pack size dropdown (250 g ⌄); the price next to it follows the choice. */
function QuantitySelector({ packs, selectedId, onSelect }) {
  return (
    <label className="ep-pack-select">
      <span className="ep-visually-hidden">Pack size</span>
      <select value={selectedId ?? ""} onChange={(e) => onSelect(Number(e.target.value))} aria-label="Pack size">
        {packs.map((pack) => (
          <option key={pack.priceId} value={pack.priceId}>
            {pack.label}
          </option>
        ))}
      </select>
      <LuChevronDown aria-hidden="true" />
    </label>
  );
}

export default memo(QuantitySelector);
